module.exports = __webpack_public_path__ + "static/media/main.bf3d5f6c.png";